export const signUpFormFields = [
  {
    type: "text",
    name: "firstName",
    label: <span className="custom-label">First Name</span>,
    className: "custom-input", 
    rules: [{ required: true, max: 15, min: 2, message: "Please enter a valid first name." }],
    placeholder: "John",
  },
  {
    type: "text",
    name: "lastName",
    label: <span className="custom-label">Last Name</span>,
    className: "custom-input",
    rules: [{ required: true, max: 15, min: 2, message: "Please enter a valid last name." }],
    placeholder: "Doe",
  },
  {
    type: "text",
    name: "name",
    label: <span className="custom-label">Company Name</span>,
    className: "custom-input",
    rules: [{ required: true, max: 40, min: 2, message: "Please enter a valid company name." }],
    placeholder: "SJ Innovation LLC",
  },
  {
    type: "number",
    name: "employeeCount",
    label: <span className="custom-label">Number of Employees</span>,
    className: "custom-input",
    placeholder: "200",
    rules: [
      { required: true, message: "This field is required." },
      {
        validator: (_, value) =>
          value && Number(value) > 0
            ? Promise.resolve()
            : Promise.reject("Number of employees must be greater than 0."),
      },
    ],
    min: 1, // This prevents negative values
  },  
  {
    type: "text",  
    name: "email",
    label: <span className="custom-label">Email</span>,
    className: "custom-input",
    rules: [
        { required: true, message: "Please enter your email address." },
        { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Please enter a valid email address." }
    ],
    placeholder: "Admin Email",
},

  {
    type: "password",
    name: "password",
    label: <span className="custom-label">Password</span>,
    className: "custom-input",
    rules: [
      { required: true, min: 8, message: "Please enter a minimum 8-character password." },
      { pattern: /^\S*$/, message: "Password cannot contain spaces." }
    ],
    placeholder: "Admin Password",
  },

  {
    name: "submit",
    label: "Sign up",
    type: "submit",
    htmlType: "submit",
    className: "btn-primary mt-4",
    buttonType: "primary",
    block: true,
  },
];
